import axiosClient from '../../configs/axios';


class UomConversionMasterService {
    // Get list 
    async getUOMConversionList(params) {
        try {
            const response = await axiosClient.get(
                `/uom-con/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addUOMConversion(data) {
        try {
            const response = await axiosClient.post('/uom-con/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteUOMConversion(data) {
        try {
            const response = await axiosClient.put(`/uom-con/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new UomConversionMasterService(); 